import { useBorrowerContext } from "../../../../store/borrower-details";
import styles from "../../../../BorrowerDetails.module.css";
import { Link } from "react-router-dom";
import { BiEdit } from "react-icons/bi";
import { VscNewFolder } from "react-icons/vsc";
import { AiOutlineDelete } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { url } from "../../../../../../../App";
import { ToastContainer, toast } from "react-toastify";
import CollateralModal from "../../../Modals/CollateralModal";
import Cookies from "js-cookie";
import { AiOutlineFolderOpen } from "react-icons/ai";
import {useParams } from "react-router-dom";

const CollateralDetails = ({ openLoader, closeLoader, permissions }) => {
  const { loanid } = useParams();
  const { borrowerData, updateBorrowerData } = useBorrowerContext();
  const fetchedBorrowerDetails = borrowerData.borrower;
  const collateral = borrowerData.collateral;
  const [collateralModal, setCollateralModal] = useState(false);
  const [collateralDetails, setCollateralDetails] = useState({});
  const navigate = useNavigate();
  const fetchedLoanDetails = borrowerData.loan;
  const latestLoan = fetchedLoanDetails.find((item) => item.loan_id === loanid);
  const [isDisbursed, setIsDisbursed] = useState(false);
  const email = Cookies.get("Email");

  useEffect(() => {
    if (loanid) {
      console.log(latestLoan)
      setIsDisbursed(latestLoan?.loan_status === "DISBURSED");
    }
    //eslint-disable-next-line
  }, [latestLoan]);

  const openCollateralDocsModal = (data) => {
    setCollateralDetails(data);
    setCollateralModal(true);
  };

  const closeCollateralDocsModal = () => {
    setCollateralDetails({});
    setCollateralModal(false);
  };

  const verifyCollateralHandler = async (data) => {
    try {
      const text =
        "Are you sure you want to Verify Collateral " +
        data.collateral_id +
        "?";
      if (!window.confirm(text)) {
        toast.error("Collateral not verified");
        return;
      }
      openLoader();
      const req = {
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
        collateral_id: data.collateral_id,
      };
      const res = await axios.post(url + "/collateral/verified", req);
      closeLoader();
      if (!res.data.auth) {
        toast.error(res.data.message);
        return null;
      }
      toast.success(res.data.message);
      window.location.reload();
    } catch (err) {
      console.error(err);
      closeLoader();
      return null;
    }
  };
  const [ip, setIp] = useState("");
  const fetch = async () => {
    try {
      const { data } = await axios.get("https://api.ipify.org");
      setIp(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetch();
  }, []);
  const deleteCollateralHandler = async (colID) => {
    try {
      const text = `Are you sure you want to delete ${colID} ?`;
      if (!window.confirm(text)) {
        return;
      }

      const req = {
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
        collateral_id: colID,
        ip: ip,
        hostname: window.location.hostname,
      };
      openLoader();
      const res = await axios.post(url + "/collateral/delete", req);
      closeLoader();
      console.log(res);
      if (!res.data.auth) {
        toast.error(res.data.message);
        return null;
      }
      toast.success(res.data.message);
      const fetchCollateralReq = {
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
        borrower_uniqueno: localStorage.getItem("uniqueID"),
      };
      const fetchCollateralRes = await axios.post(
        url + "/borrower/borrowertoalldetails",
        fetchCollateralReq
      );
      if (!fetchCollateralRes.data.auth) {
        return null;
      }
      updateBorrowerData((prevState) => ({
        ...prevState,
        collateral: fetchCollateralRes.data.message.collateral,
      }));
    } catch (err) {
      console.error(err);
      closeLoader();
      return null;
    }
  };

  return (
    <>
      <ToastContainer />
      {collateralModal && (
        <CollateralModal
          closeModal={closeCollateralDocsModal}
          details={collateralDetails}
          openLoader={openLoader}
          closeLoader={closeLoader}
          isDisbursed={isDisbursed}
          isDownload={email === "rupesh.bishnoi@credin.in" || permissions.download_collateral_document === true}
          isDelete={email === "rupesh.bishnoi@credin.in" || permissions.delete_collateral_document === true}
        />
      )}
      {permissions.add_collateral && !isDisbursed && (
        <div className={styles.collateralButtons}>
          <button
            className={styles.addCollateralButton}
            style={{ fontSize: "0.9rem", margin: ".5rem" }}
            onClick={() =>
              navigate("/collateral/add", {
                state: {
                  fetchedBorrowerDetails,
                },
              })
            }
          >
            + Add Collateral
          </button>
        </div>
      )}
      {collateral?.filter((collateral) => collateral.collateral_loan_id === loanid).map((data, index) => {
        return (
          <div key={index} className={styles.collateralData}>
            <div className={styles.collateralDataContainer}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  {/* <p className={styles.coapplicantDataText}>
          Name of Co-Applicant
        </p> */}
                  {/* <p
          style={{
            fontSize: "1.5rem",
            color: "gray",
            fontWeight: "bold",
          }}
        >
          Isha Patel
        </p> */}
                </div>
                {/* <div> */}
                {/* <p style={{ fontSize: "1rem", color: "gray", fontWeight:"bold" }}>
          Action
        </p> */}

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                  }}
                >
                  {permissions.edit_collateral && !isDisbursed && (
                    <Link to="/collateral/edit" state={data}>
                      <BiEdit
                        color="green"
                        title="Edit"
                        cursor="pointer"
                        size={18}
                      />
                    </Link>
                  )}
                  {permissions.view_collateral_document ||
                  permissions.download_collateral_document ? (
                    <VscNewFolder
                      color="#272220"
                      title="View Docs"
                      cursor="pointer"
                      style={{ marginLeft: "1rem" }}
                      size={18}
                      onClick={() => openCollateralDocsModal(data)}
                    />
                  ) : (
                    ""
                  )}
                  {permissions.view_collateral && (
                    <Link to="/viewcollateraldetails" state={data}>
                      <AiOutlineFolderOpen
                        color="#034ea1"
                        title="View Collateral Details"
                        cursor="pointer"
                        style={{
                          marginLeft: "1rem",
                        }}
                        size={18}
                      />
                    </Link>
                  )}
                  {permissions.delete_collateral && !isDisbursed && (
                    <AiOutlineDelete
                      color="red"
                      title="Delete"
                      cursor="pointer"
                      style={{ marginLeft: ".7rem" }}
                      size={18}
                      onClick={() =>
                        deleteCollateralHandler(data.collateral_id)
                      }
                    />
                  )}
                  {permissions.verify_collateral && !isDisbursed && (
                    <>
                      <input
                        type="checkbox"
                        style={{
                          height: ".9rem",
                          width: ".9rem",
                          marginLeft: ".7rem",
                        }}
                        onChange={() => verifyCollateralHandler(data)}
                        checked={data.collateral_status ? true : false}
                        disabled={isDisbursed || (data.collateral_status ? true : false)}
                      />
                      <p
                        style={{
                          fontSize: "0.9rem",
                          color: "gray",
                          marginLeft: ".2rem",
                          fontWeight: "bold",
                        }}
                      >
                        Verify
                      </p>
                    </>
                  )}
                </div>
              </div>
              {/* <div
      style={{
        display: "flex",
        justifyContent: "space-between",
      }}
    > */}

              {/* <div> */}
              {/* <p className={styles.collateralDataText}>
          Borrower Unique Number
        </p> */}
              {/* <p
          style={{
            fontSize: "1rem",
            color: "gray",
            fontWeight: "bold",
          }}
        >
          CR13554246124
        </p> */}
              {/* </div> */}
              {/* <div>
        <p style={{ fontSize: "1rem", color: "gray", fontWeight:"bold" }}>
          Action
        </p>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-evenly",
          }}
        >
          <AiOutlineFolderOpen
            sx={{ color: "#034ea1" }}
            fontSize="1rem"
            cursor="pointer"
          />
          <BiEdit
            fontSize="1rem"
            color="green"
            cursor="pointer"
            style={{ marginLeft: ".2rem" }}
          />
          <RiDeleteBin7Line
            color="red"
            fontSize="1rem"
            cursor="pointer"
            style={{ marginLeft: ".2rem" }}
          />
          <input
            type="checkbox"
            style={{
              height: ".9rem",
              width: ".9rem",
              marginLeft: ".2rem",
            }}
          />
          <p style={{ fontSize: "1rem", color: "gray", fontWeight:"bold",marginLeft:".2rem" }}>
            Verify
          </p>
        </div>
      </div> */}

              {/* </div> */}
              <hr
                style={{
                  backgroundColor: "gray",
                  width: "100%",
                  margin: ".2rem 0",
                }}
              />
              <table width="100%" className={styles.myClass}>
                <thead>
                  <tr>
                    <th>Loan ID</th>
                    <th>Collateral ID</th>
                    <th>Type Of Collateral</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{data.collateral_loan_id}</td>
                    <td>{data.collateral_id}</td>
                    <td>{data.collateral_type}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default CollateralDetails;
